module.exports = __webpack_public_path__ + "img/icon-transport.ef4d9fd3.svg";